import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useFormContext } from 'react-hook-form';
import { Toggle, IconButton, Icon } from 'rsuite';
import {
  deleteElement,
  getIsElementRequired,
  updateRequired,
  getRewardSettings,
  getCampaignElements,
} from '@src/redux/modules/campaigns';
import styles from '@src/components/CampaignEdit/EditActions.module.less';

const EditActions = ({
  _deleteElement,
  _updateRequired,
  idx,
  isDeleteDisabled,
  isElementRequired,
  isElementRequiredOverride,
  showRequiredSwitch,
  isRequireEditDisabled,
  isRewardRequiredField,
}) => {
  const { unregister } = useFormContext();

  const shouldDisableDelete = isDeleteDisabled || isRewardRequiredField;

  return (
    <section className={styles.vpElementEditActions}>
      { showRequiredSwitch &&
        <div className={styles.vpRequiredSwitchContainer}>
          <div className={styles.vpRequiredLabel}>
            Required?
          </div>
          <Toggle
            checked={isElementRequired || isElementRequiredOverride}
            disabled={isRequireEditDisabled}
            onChange={(checked) => {
              _updateRequired(idx, checked);
            }}
          />
        </div>
      }
      <IconButton
        data-testid={`question-delete-${idx}`}
        disabled={shouldDisableDelete}
        color="red"
        onMouseDown={() => {
          unregister(`campaignElements[${idx}]`);
          _deleteElement(idx);
        }}
        icon={<Icon icon="trash" />}
      />
    </section>
  );
}

EditActions.propTypes = {
  _deleteElement: PropTypes.func,
  _updateRequired: PropTypes.func,
  idx: PropTypes.number,
  isDeleteDisabled: PropTypes.bool,
  isElementRequired: PropTypes.bool,
  isElementRequiredOverride: PropTypes.bool,
  showRequiredSwitch: PropTypes.bool,
  isRequireEditDisabled: PropTypes.bool,
  isRewardRequiredField: PropTypes.bool,
};

function mapStateToProps(state, ownProps) {
  const rewardSettings = getRewardSettings(state);
  const campaignElements = getCampaignElements(state);
  const element = campaignElements[ownProps.idx];
  const label = element?.label?.toLowerCase() || '';

  const isNameField = label.includes('first name') || label.includes('name');
  const isEmailField = label.includes('email');
  const isRewardRequiredField =
    rewardSettings?.enabled && (isNameField || isEmailField);

  return {
    isElementRequired: getIsElementRequired(state, ownProps.idx),
    isRewardRequiredField,
  };
}

const mapDispatchToProps = {
  _deleteElement: deleteElement,
  _updateRequired: updateRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(EditActions);



// WEBPACK FOOTER //
// ./src/components/CampaignEdit/EditActions.jsx